import src from "IMAGE";
export default { src, width: 511, height: 86, blurWidth: 0, blurHeight: 0};
